/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupplementalFormSchemaCondition
 */
export interface SupplementalFormSchemaCondition {
    /**
     * 
     * @type {string}
     * @memberof SupplementalFormSchemaCondition
     */
    question_id: string;
    /**
     * 
     * @type {string}
     * @memberof SupplementalFormSchemaCondition
     */
    value_is: string;
}

/**
 * Check if a given object implements the SupplementalFormSchemaCondition interface.
 */
export function instanceOfSupplementalFormSchemaCondition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "question_id" in value;
    isInstance = isInstance && "value_is" in value;

    return isInstance;
}

export function SupplementalFormSchemaConditionFromJSON(json: any): SupplementalFormSchemaCondition {
    return SupplementalFormSchemaConditionFromJSONTyped(json, false);
}

export function SupplementalFormSchemaConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalFormSchemaCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'question_id': json['question_id'],
        'value_is': json['value_is'],
    };
}

export function SupplementalFormSchemaConditionToJSON(value?: SupplementalFormSchemaCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'question_id': value.question_id,
        'value_is': value.value_is,
    };
}

